module.exports = __webpack_public_path__ + "img/11.77544474.png";